export default {
    index:   { method: 'get', url: 'audit-logs' },
    payload: { method: 'get', url: 'audit-logs/{id}/payload' },
}
